export default {
      id: "sb-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.adde2a28.svg#sb",
      toString: function () {
        return this.url;
      }
    }